import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import memoizeOne from 'memoize-one';
import OverviewTable from '../../../components/Table/OverviewTable';
import localization from '../../../i18n/localization';

const columnDefinition = [
  { id: 'saleId', label: 'Sale ID' },
  { id: 'issuedTo', label: 'Ausgestellt auf' },
  { id: 'createdAt', label: 'Erstellt am' },
  { id: 'validFrom', label: 'G\u00fcltig ab' },
  { id: 'state', label: 'Status' },
];

const getColumnDefinition = memoizeOne(showUser => {
  return showUser
    ? columnDefinition
    : columnDefinition.filter(def => def.id !== 'issuedTo');
});

const transform = memoizeOne(orders =>
  orders.map(order => ({
    id: order.id,
    saleId: order.saleId,
    issuedTo: order.user ? order.user.email : '',
    createdAt: moment(order.createdAt).format('DD.MM.YYYY HH:mm'),
    validFrom: moment(order.validFrom).format('DD.MM.YYYY'),
    state: localization.de[order.state],
  }))
);

export default function BlsOverviewTable({ orders, onOrderClick, showUser }) {
  return (
    <OverviewTable
      columnDefinition={getColumnDefinition(showUser)}
      data={transform(orders)}
      onRowClick={order => onOrderClick(order.id)}
    />
  );
}

BlsOverviewTable.propTypes = {
  orders: PropTypes.array,
  onOrderClick: PropTypes.func.isRequired,
  showUser: PropTypes.bool,
};

BlsOverviewTable.defaultProps = {
  orders: [],
  showUser: true,
};



// WEBPACK FOOTER //
// ./src/views/bls/components/BlsOverviewTable.jsx